import React,{useState,useEffect} from 'react';
import './HelpAndFAQDashboard.css';
import { Icon } from '../../../globalUtils/globalIcons';
import { CustomBreadCrumbs, CustomButton} from '../../../globalUtils/globalExports';
import { createBreadCrumbProps} from '../../../globalUtils/globalHooks';
import { useNavigate } from 'react-router-dom';
import articlesMenu from './helpAndFAQData/articles-menu.json';
import CustomSidePopover from '../CustomSidePopover';
import ContactUsSidebar from '../ContactUsSidebar';



const HelpAndFAQDashboard: React.FC = () => {
    const navigate = useNavigate();
    const helpAndFaqTopics = Object.values(articlesMenu)
    const [colCount,setColCount] = useState<number>(3);
    const [isContactUsSidebarOpen,setIsContactUsSidebarOpen] = useState<boolean>(false);
    const breadCrumbArray = createBreadCrumbProps(
        {
            breadCrumbProps: [
                {
                    objectType: 'link',
                    id: 'supportCentre',
                },
                {
                    objectType: 'text',
                    id: 'text',
                    text: 'Help and FAQ'
                }
            ]
        }
    )


    useEffect(()=>{
        // This controls the number of grid columns as per the screen size.
        const handleScreenSizeChange = ()=>{
            const newColCount = window.innerWidth <= 1000 ? 2:3;
            setColCount(newColCount)
        }
        handleScreenSizeChange();
        window.addEventListener('resize',handleScreenSizeChange);
        return () => {
            window.removeEventListener('resize', handleScreenSizeChange);
        };
    },[])


    // const helpAndFaqTopics = [
    //     {
    //         id: 'dashboard',
    //         icon: 'rms__support__ai__chatbot__icon-small',
    //         guidesCount: 1,
    //         label: 'Dashboard',
    //         description: 'Learn how to view, customize, and interpret data on your main dashboard.'
    //     },
    //     {
    //         id: 'alarms',
    //         icon: 'rms__support__ai__chatbot__icon-small',
    //         guidesCount: 4,
    //         label: 'Alarm',
    //         description: 'Find out how alarms work, how to manage notifications, and resolve issues.'
    //     },
    //     {
    //         id: 'chargers',
    //         icon: 'rms__support__ai__chatbot__icon-small',
    //         guidesCount: 2,
    //         label: 'Chargers',
    //         description: 'Understand charger settings, status meanings, and troubleshooting steps.'
    //     },
    //     {
    //         id: 'chargingStations',
    //         icon: 'rms__support__ai__chatbot__icon-small',
    //         guidesCount: 1,
    //         label: 'Charging Stations',
    //         description: 'Know how to add, edit, and monitor charging stations effectively.'
    //     },
    //     {
    //         id: 'customers',
    //         icon: 'rms__support__ai__chatbot__icon-small',
    //         guidesCount: 1,
    //         label: 'Customers',
    //         description: 'Get help with managing customer accounts, profiles, and activity records.'
    //     },
    //     {
    //         id: 'accessControls',
    //         icon: 'rms__support__ai__chatbot__icon-small',
    //         guidesCount: 1,
    //         label: 'Access Controls',
    //         description: 'Learn how to set user roles, permissions, and security access levels.'
    //     },  
    //     {
    //         id: 'reports',
    //         icon: 'rms__support__ai__chatbot__icon-small',
    //         guidesCount: 1,
    //         label: 'Reports',
    //         description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
    //     }, 
    // ]

    const getIconName = (cardLabel : string):string => {
        const modifiedCardName = cardLabel?.toLowerCase()?.replaceAll(' ','_');
        return 'rms__support__centre__help__and__faq-topic-'+modifiedCardName+'-icon';
    }


    const contactUsBtn = {
        id:'rms__support__centre__help__and__faq__dashboard-contact-us-btn',
        className:'rms__support__centre__help__and__faq__dashboard__contact__us__btn',
        text:'Contact us',
        variant:'filled',
        iconClassName:'rms__support__help__btn__icon',
        onClick:()=>{setIsContactUsSidebarOpen(true);}
    }

    const handleCardClick = (cardLabel:string)=>{
        navigate('/help-and-faq?topic='+cardLabel?.trim()?.toLowerCase())
    }

    return (
        <div className='rms__support__centre__help__and__faq__dashboard__container-wrap'>
            <div className='rms__support__centre__help__and__faq__dashboard__container'>
                <div className='rms__support__centre__help__and__faq__dashboard__header-container'>
                    <div className='rms__support__centre__help__and__faq__header'>
                        <div className='rms__support__centre__help__and__faq__header-left'>
                            <div className='rms__support__centre__help__and__faq__header-bread-crumb-container'>
                                <CustomBreadCrumbs breadCrumbs={breadCrumbArray} />
                            </div>
                            <div className='rms__support__centre__help__and__faq__header__heading-container'>
                                <div className='rms__support__centre__help__and__faq__header__heading'>
                                    Help and FAQ
                                </div>
                                <div className='rms__support__centre__help__and__faq__header-description'>
                                    Get quick answer & guidance on using the platform.
                                </div>
                            </div>
                        </div>
                        <div className='rms__support__centre__help__and__faq__header-right'>
                            <Icon iconClassName='rms__support__centre__help__and__faq-header-icon' />
                        </div>
                    </div>
                </div>
                <div className='rms__support__centre__help__and__faq__dashboard__body'>
                    {
                        <div className='rms__support__centre__help__and__faq__dashboard__body-topics'>
                        {
                             helpAndFaqTopics && helpAndFaqTopics?.length > 0 && helpAndFaqTopics.map((card,index) => {
                                const totalCompleteRows = Math.floor(helpAndFaqTopics?.length / colCount);
                                return (
                                    <div key={card?.id} className={'rms__support__centre__help__and__faq-topics-card ' + 
                                        ((index >= totalCompleteRows * colCount)?'rms__support__centre__help__and__faq-topics-card-border-bottom-disabled ' : '') + 
                                        ((index%colCount === colCount - 1)?'rms__support__centre__help__and__faq-topics-card-border-right-disabled': '')}
                                        onClick={()=>handleCardClick(card?.label)}
                                    >
                                        <div className='rms__support__centre__help__and__faq-topics-card-left'>
                                            <div className='rms__support__centre__help__and__faq-topics-card-icon-container'>
                                                <Icon iconClassName={getIconName(card?.label)} />
                                            </div>
                                        </div>
                                        <div className='rms__support__centre__help__and__faq-topics-card-right'>
                                            <div className='rms__support__centre__help__and__faq-topics-card-right-header'>
                                                <div className='rms__support__centre__help__and__faq-topics-card-right-header-heading'>
                                                    {card?.label}
                                                </div>
                                                <div className='rms__support__centre__help__and__faq-topics-card-right-header-guide-count'>
                                                    <span className='rms__support__centre__help__and__faq-topics-card-right-header-guide-count-count'>{card?.guidesCount}</span>
                                                    <span className='rms__support__centre__help__and__faq-topics-card-right-header-guide-count-label'>{card?.guidesCount && card?.guidesCount > 1 ? 'Topics' : 'Topic'}</span>
                                                </div>
                                            </div>
                                            <div className='rms__support__centre__help__and__faq-topics-card-right-body'>
                                                {card?.description}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })

                        }
                        </div>
                    }
                </div>
            </div>
            <div className='rms__support__centre__help__and__faq__dashboard-background-icon'>
                <Icon iconClassName='rms__support__centre__help__and__faq-background-icon' />
            </div>
            <div className='rms__support__centre__help__and__faq__dashboard-contact-us-btn'>
                <CustomButton 
                buttonId={contactUsBtn?.id}
                buttonVariant={contactUsBtn?.variant}
                buttonText={contactUsBtn?.text} 
                buttonIconClassName={contactUsBtn?.iconClassName}
                btnClassName={contactUsBtn?.className}
                handleClick={contactUsBtn?.onClick}
                handleKeyPress={()=>{}}
                />
            </div>
            <>
                {
                    isContactUsSidebarOpen && <CustomSidePopover
                    id={'ai__smart__assisst__contact__us__popup'} 
                    open={isContactUsSidebarOpen} 
                    handleClose={()=>{setIsContactUsSidebarOpen(false)}}
                    /*eslint-disable react/no-children-prop*/
                    children={
                        <ContactUsSidebar/>
                    }/>
                }
            </>
        </div>
    )
}


export default HelpAndFAQDashboard;